import { AppointmentConfirmationStatus } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { AxisGroup } from '@frontend/charts';
import { i18next } from '@frontend/i18n';

export const APPOINTMENT_CONFIRMATION_STATUS_OPTIONS = [
  {
    label: i18next.t('Unconfirmed', { ns: 'analytics' }),
    value: AppointmentConfirmationStatus.APPOINTMENT_CNF_STATUS_UNCONFIRMED,
  },
  {
    label: i18next.t('Confirmed', { ns: 'analytics' }),
    value: AppointmentConfirmationStatus.APPOINTMENT_CNF_STATUS_CONFIRMED,
  },
];

export const APPOINTMENT_CONFIRMATION_STATUS_Y_AXIS_GROUPS: AxisGroup[] = [
  {
    label: i18next.t('Confirmation Status', { ns: 'analytics' }),
    key: 'confirmationStatus',
    icon: 'check',
    selectionType: 'checkbox',
    options: APPOINTMENT_CONFIRMATION_STATUS_OPTIONS,
  },
];
